import ReactJson from "react-json-view";
import React from "react";
//import Tooltip from "@material-ui/core/Tooltip";
import MyTooltip from "../components/Tooltip"
import Localize from "../components/Localize/Localize";

const moment = require("moment");
const utf8 = require('utf8');

function split_in_lines(t, s) {
  let output = "";
  for (let i = 0; i < t.length; i += s) {
    output += t.substring(i, i + s) + '\n';
  }
  return output;
}

function resolve(options, path, obj, separator='.') {
  let result = "caca";
  try {
    const properties = Array.isArray(path) ? path : path.split(separator);
    result = properties.reduce((prev, curr) => prev && prev[curr], obj);

    // Manuel reduce :|
    let acc = obj;
    properties.map(p => acc = acc[p]);
    result = acc;

    // If the "array" object does not exits, just take it by name
    if (result === undefined) result = obj[path];

    if (options.purge && result) result = result.replace(options.purge, "");

    //if (options.formula) {
    //  result = options.formula(obj);
    //}

  }
  catch(e) {
    console.error("Error in resolve!", e)
  }

  return result !== undefined ? result: "--";
}


//function column(pollo, id, showAs='text', linkTo='', options={}) {
function column(pollo, id, options = {}, key = "") {

  const showAs = options.showAs || "text";
  const linkTo = options.linkTo || "";

  return({
    options: options,
    key: id,
    label: showAs === "button" ? "" : key != null ? Localize.translate(key) : id,
    sortable: showAs !== "button",
    value: (row) => { return resolve(options, id, row) },
    render: (row) => {
      if (id === "elapsed") {
        console.log(row);
      }

      let tooltip_content = '';
      try {
        if (showAs === 'json') {
          tooltip_content = JSON.stringify(resolve(options, id, row)/*, null, 4*/);
          tooltip_content = split_in_lines(tooltip_content, 40)
        }
      }
      catch(e)
      {
        console.error("Could not process: " + row[id]);
        tooltip_content = row[id];
      }

      const formulated = options.formula ? options.formula(row, id): resolve(options, id, row);

      let formatted = "";
      if (formulated === "-") formatted = "-";
      else if (formulated === "") formatted = "";
      else if (formulated === "Total") formatted = "Total";
      else if (formulated === null) formatted = "null";
      else switch(showAs) {
        case "text":
          formatted = options && options.numeric ?
            options.decimals ?
              formulated.toFixed(options.decimals) : formulated.toLocaleString()
              : formulated;
          break;
        case "enum":
          let enumed = formulated
          try {
            enumed = options.enum[formulated];
          }
          catch(e) {
            console.error(formulated + " not in " + JSON.stringify(options.enum))
          }
          formatted = enumed;
          break;
        case "bool":
          formatted = formulated?.toString().toLowerCase() === "true" ? "true" : "false";
          break;
        case "date":
          formatted = new moment(formulated).format("YYYY-MM-DD HH:mm:ss");
          break;
        case "timestamp":
          formatted = new moment.unix(formulated).utc().format("YYYY-MM-DD HH:mm:ss");
          break;
        case "number":
          formatted = parseInt(formulated).toLocaleString('en-US');
          break;
        case "money":
          formatted = parseFloat(formulated).toFixed(2).toLocaleString('en-US') + "$";
          break;
        case "int":
          formatted = parseInt(formulated).toLocaleString('en-US');
          break;
        case "float":
          formatted = parseFloat(formulated.replace(",", ".")).toLocaleString('en-US', {minimumFractionDigits: 2});
          break;
        case "date-short":
          formatted = new moment(formulated).format("YYYY-MM-DD");
          break;
        case "device":
          formatted = formulated && formulated.split("-")[0].substring(0, 8);
          break;
        case "event":
          formatted = formulated.replace("type.googleapis.com/", "")
            .replace("tangelogames.events.", "")
            .replace("tangelogames.api.", "");
          break;
        case "event_short":
          formatted = formulated.substring(formulated.lastIndexOf(".") + 1);
          break;
        case "platform":
          formatted = formulated.replace("PLATFORM_", "");
          break;
        case "json-text":
          try {
            // formatted = JSON.stringify(formulated);
            formatted = JSON.stringify(formulated, (key, value) => { if (value !== null) return value });
            const lineWidth = options.lineWidth || 65536;
            formatted = split_in_lines(formatted, lineWidth);
          }
          catch(e) {
            formatted = formulated;
          }
          // formatted = JSON.stringify(formulated, (key, value) => { if (value !== null) return value });
          // const lineWidth = options.lineWidth || 65536;
          // formatted = split_in_lines(formatted, lineWidth);
          break;
        case "json-alert":
          try {
            // formatted = JSON.stringify(formulated);
            const to_string = JSON.stringify(formulated, (key, value) => { if (value !== null) return value });
            // console.log(to_string);
            formatted = <span style={{cursor: "zoom-in"}} onClick={() => {
//              return <Alert severity={"info"}>{to_string}</Alert>
              return(alert(to_string))
            }}>Expand!</span>
          }
          catch(e) {
            formatted = formulated;
          }
          // formatted = JSON.stringify(formulated, (key, value) => { if (value !== null) return value });
          // const lineWidth = options.lineWidth || 65536;
          // formatted = split_in_lines(formatted, lineWidth);
          break;
        case "json":
          formatted = <span style={{color: "blue", cursor: "copy"}} onClick={async () => {await navigator.clipboard.writeText(row[id])}}>Copy!</span>
          // formatted = 'json'; // row[id] && <ReactJson src={JSON.parse(row[id])} enableClipboard={false} collapsed={true}/>
          break;
        case "ts":
          formatted = moment.unix(formulated).toISOString();
          break;
        case "thumb":
          formatted = <img src={formulated} height={"128px"} alt={formulated}/>
          break;
        case "component":
          formatted = formulated;
          break;
        case "image":
          formatted = <img src={formulated} height={"64px"} alt={"img"} onClick={() => window.open(formulated)}/>
          break;
        case "button":
          const buttonStyle = {
            padding: "5px 20px",
            backgroundColor: "#3498db",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "1rem",
          };
          
          formatted = <button style={buttonStyle}>{formulated}</button >
          break;
        case "download":
          formatted = <a href={formulated} target={"_blank"}>Download</a>
          break;
        default:
          formatted = "?";
          break;
      }

      if (options.linkTo && options.showAs !== "button") {
        formatted = <span style={{color: "blue", textDecoration: "underline"}}>{formulated}</span>;
      }

      let cursor_style = {cursor: 'default'};
      if (options.cursor) {
        cursor_style = {cursor: options.cursor};
      }
      else {
        if (linkTo) {
          cursor_style = {cursor: 'pointer'};
        }
      }

      const display =
        <div style={cursor_style}
          onClick={
          linkTo ?
           async () => { const url = await linkTo(pollo, row); if (url) window.open(url) }
           :
           () => { return null }
          }
        >
          {
            formatted
          }
        {/*{*/}
        {/*showAs === 'text' ?*/}
        {/*  options && options.numeric ?*/}
        {/*    formulated.toLocaleString('en-US') : formulated*/}
        {/*  :*/}
        {/*  showAs === "date" ?*/}
        {/*    new moment(formulated).format("YYYY-MM-DD HH:mm:ss")*/}
        {/*    :*/}
        {/*    showAs === "date-short" ?*/}
        {/*      formulated !== "-" ? new moment(formulated).format("YYYY-MM-DD") : "-"*/}
        {/*      // formulated !== "-" ? new moment(formulated).format("YYYY-MM-DD") : "-"*/}
        {/*      :*/}
        {/*      showAs === "device" ?*/}
        {/*        formulated && formulated.split("-")[0].substring(0, 8)*/}
        {/*        :*/}
        {/*        showAs === "event" ?*/}
        {/*          formulated.replace("type.googleapis.com/tangelogames.events.", "")*/}
        {/*          :*/}
        {/*          showAs === "json-text" ?*/}
        {/*            JSON.stringify(formulated)*/}
        {/*            :*/}
        {/*            'json' // row[id] && <ReactJson src={JSON.parse(row[id])} enableClipboard={false} collapsed={true}/>*/}
        {/*}*/}
        </div>;

      if (showAs === "json") {
        return(
          <MyTooltip
            title={
              <span style={{
                width: '800px',
                minWidth: '800px',
                fontSize: '14px',
                whiteSpace: 'pre',
              }}
              >
                {tooltip_content}
              </span>
            }
          >
            {formatted}
          </MyTooltip>
        );
      }

      if (options.tooltip) {
        return(
          <MyTooltip
            enterDelay={0}
            title={
              <span style={{
                width: '200px',
                minWidth: '200px',
                fontSize: '14px',
                whiteSpace: 'pre',
              }}
              >
                {options.tooltip}
              </span>
            }
          >
            <span>{display}</span>
          </MyTooltip>
        );

      }

      return (display);

      return(
        showAs === "json" ?
          <MyTooltip
            title={
              <span style={{
                width: '800px',
                minWidth: '800px',
                fontSize: '14px',
                whiteSpace: 'pre',
              }}
              >
                {tooltip_content}
              </span>
            }
          >
          <span>json</span>
          </MyTooltip>
          :
          display
      );
    },
    numeric: options && options.numeric === true,
    header: options && options.header,
    style: options && options.style || {}
  });
}

export { column };
// exports.column = column;
